const PRODUCT_CONTEXT_EVENT = 'neuracoil:product-context';
const VISIBILITY_HYSTERESIS = 32;

const onReady = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

onReady(() => {
  const bar = document.querySelector('[data-neuracoil-header-buy]');
  if (!(bar instanceof HTMLElement) || bar.dataset.ready === 'true') return;
  bar.dataset.ready = 'true';

  const header = bar.closest('header-component');
  const productSectionSelector = bar.dataset.productSectionSelector || '[data-neuracoil-product-page]';
  const productSection = document.querySelector(productSectionSelector);
  const utilities = header?.querySelector('[data-neuracoil-header-utilities]');
  const utilityTargets = [
    utilities,
    ...Array.from(header?.querySelectorAll('.header__column--right > .search-action') || []),
  ].filter((target) => target instanceof HTMLElement);
  const productLink = bar.querySelector('[data-neuracoil-header-product-link]');
  const configButton = bar.querySelector('[data-neuracoil-header-config]');
  const variantText = bar.querySelector('[data-neuracoil-header-variant]');
  const priceText = bar.querySelector('[data-neuracoil-header-price]');
  const submitButton = bar.querySelector('[data-neuracoil-header-submit]');
  const submitLabel = bar.querySelector('[data-neuracoil-header-submit-label]');
  const unavailableLabel = submitButton?.dataset.unavailableLabel || 'Reserve my build';
  let isVisible = false;
  let ticking = false;

  if (!(header instanceof HTMLElement) || !(productSection instanceof HTMLElement)) return;

  const scrollToProduct = () => {
    productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const collapsedHeaderHeight = () => {
    return Math.max(0, header.getBoundingClientRect().height);
  };

  const setVisible = (visible) => {
    if (visible === isVisible) return;
    isVisible = visible;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    bar.inert = !visible;
    header.dataset.neuracoilHeaderBuyActive = visible ? 'true' : 'false';

    for (const target of utilityTargets) {
      target.inert = visible;
      target.hidden = visible;
      target.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }
  };

  const updateVisibility = () => {
    ticking = false;
    const productRect = productSection.getBoundingClientRect();
    const triggerOffset = collapsedHeaderHeight() + 1;

    if (!isVisible && productRect.bottom <= triggerOffset) {
      setVisible(true);
    } else if (isVisible && productRect.bottom > triggerOffset + VISIBILITY_HYSTERESIS) {
      setVisible(false);
    }
  };

  const requestVisibilityUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateVisibility);
  };

  const submitMainProductForm = () => {
    const form = productSection.querySelector('.neuracoil-product-page__form');
    const mainSubmit = productSection.querySelector('[data-add-to-cart]');

    if (!(form instanceof HTMLFormElement) || !(mainSubmit instanceof HTMLButtonElement) || mainSubmit.disabled) {
      scrollToProduct();

      const notifyEmail = productSection.querySelector('.neuracoil-product-page__notify-input');
      window.setTimeout(() => {
        if (notifyEmail instanceof HTMLInputElement) notifyEmail.focus({ preventScroll: true });
      }, 500);
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(mainSubmit);
      return;
    }

    mainSubmit.click();
  };

  const updateProductContext = (event) => {
    const detail = event.detail || {};

    if (variantText instanceof HTMLElement && typeof detail.variantTitle === 'string' && detail.variantTitle.trim()) {
      variantText.textContent = detail.variantTitle;
    }

    if (priceText instanceof HTMLElement && typeof detail.price === 'string' && detail.price.trim()) {
      priceText.textContent = detail.price;
    }

    if (submitButton instanceof HTMLButtonElement) {
      const available = detail.available !== false;
      submitButton.disabled = false;
      submitButton.dataset.waitlist = available ? 'false' : 'true';

      if (submitLabel instanceof HTMLElement) {
        submitLabel.textContent = available ? 'Add to Bag' : unavailableLabel;
      }
    }
  };

  productLink?.addEventListener('click', (event) => {
    event.preventDefault();
    scrollToProduct();
  });

  configButton?.addEventListener('click', scrollToProduct);
  submitButton?.addEventListener('click', submitMainProductForm);

  window.addEventListener(PRODUCT_CONTEXT_EVENT, updateProductContext);
  if (window.neuracoilProductContext) {
    updateProductContext({ detail: window.neuracoilProductContext });
  }
  window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
  window.addEventListener('resize', requestVisibilityUpdate);
  requestVisibilityUpdate();
});
